'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AdditionalAddons = exports.PrimaryAddons = undefined;

var _Hubs$HUB_MARKETING$H;

var _MerchandiseIds = require('self-service-api/constants/MerchandiseIds');

var _Hubs = require('self-service-api/constants/Hubs');

var _Hubs2 = _interopRequireDefault(_Hubs);

var _Editions = require('self-service-api/constants/Editions');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var PrimaryAddons = exports.PrimaryAddons = [_MerchandiseIds.ADDON_CMS, _MerchandiseIds.ADDON_REPORTING, _MerchandiseIds.ADDON_ADS];

var AdditionalAddons = exports.AdditionalAddons = [_MerchandiseIds.ADDON_DEDICATED_IP, _MerchandiseIds.ADDON_TRANSACTIONAL_EMAIL, _MerchandiseIds.ADDON_CUSTOM_SSL, _MerchandiseIds.ADDON_API];

exports.default = (_Hubs$HUB_MARKETING$H = {}, _defineProperty(_Hubs$HUB_MARKETING$H, _Hubs2.default.HUB_MARKETING, {
  primaryMerch: PrimaryAddons,
  additionalMerch: AdditionalAddons,
  editionSpecificMerchMap: _defineProperty({}, _Editions.ENTERPRISE, [_MerchandiseIds.ADDON_BRAND_DOMAIN])
}), _defineProperty(_Hubs$HUB_MARKETING$H, _Hubs2.default.HUB_SALES, {
  primaryMerch: PrimaryAddons
}), _defineProperty(_Hubs$HUB_MARKETING$H, _Hubs2.default.HUB_SERVICE, {
  primaryMerch: PrimaryAddons
}), _defineProperty(_Hubs$HUB_MARKETING$H, 'growth-suite', {
  primaryMerch: PrimaryAddons,
  additionalMerch: [_MerchandiseIds.ADDON_DEDICATED_IP, _MerchandiseIds.ADDON_TRANSACTIONAL_EMAIL, _MerchandiseIds.ADDON_CUSTOM_SSL, _MerchandiseIds.ADDON_API],
  editionSpecificMerchMap: _defineProperty({}, _Editions.ENTERPRISE, [_MerchandiseIds.ADDON_BRAND_DOMAIN])
}), _Hubs$HUB_MARKETING$H);


//////////////////
// WEBPACK FOOTER
// ./js/constants/HubToAddonsMap.js
// module id = 257
// module chunks = 3 4 5